import { Injectable } from "@angular/core";

@Injectable()
export class RuntimeValidator {
    public validate(fieldValue: string | null): string | null {
        if (!fieldValue) {
            return null;
        }

        const parts = fieldValue.split(":");
        if (parts.length !== 2) {
            return "Invalid value. Must be in format mm:ss";
        }

        const minutes = parts[0];
        const seconds = parts[1];

        if (!minutes.match(/^[0-9]{1,3}$/)) {
            return "Invalid minutes. Must be a number between 0-999.";
        }

        if (!seconds.match(/^[0-5][0-9]$/)) {
            return "Invalid seconds. Must be a number between 00-59.";
        }

        return null;
    }

}
